$(document).ready(function(){
    $(document).on('click touchend', '.utility-nav-search, .close-header-search', function(event){
        if (dragging) return;

        event.preventDefault();

        $('.header-search').toggleClass('visible');

        // Remove focus if we close header
        if(!$('.header-search').hasClass('visible')) {
            $(this).blur();
        }
    });
});